
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/horse-racing/consensus-picks-tool",
      function () {
        return require("private-next-pages/horse-racing/consensus-picks-tool.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/horse-racing/consensus-picks-tool"])
      });
    }
  